<template>
    <div class="body-scoped">
        <div class="w-full h-full background-app">
            <div class="text-center flex h-screen">
                
                <div class="m-auto full-size">
                    <div class="main-body-area mt-40">
                        <svg class="m-auto mb-4" width="54" height="50" viewBox="0 0 54 50" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.1721 0.9375C13.0992 0.9375 11.5085 1.97539 9.92773 3.68555L2.16057 13.5182C0.233723 16.0516 0.35767 18.7318 2.1093 20.8899L23.6598 47.521C24.5478 48.5546 25.7619 49.0742 27.0037 49.0557C28.2455 49.0742 29.4596 48.5546 30.3476 47.521L51.8981 20.8899C53.6497 18.7318 53.7737 16.0516 51.8468 13.5182L44.0797 3.68555C42.4988 1.97539 40.9081 0.9375 37.8353 0.9375H16.1721Z" fill="url(#paint0_linear_50_4)"/><path d="M13.249 17.3501L27.0434 49.1376C27.0446 49.1376 27.0457 49.1376 27.0468 49.1376H27.0477L40.8412 17.3501C34.6746 17.3501 30.3665 16.6107 27.0177 16.6107C21.0831 16.6107 18.1617 17.3501 13.249 17.3501Z" fill="url(#paint1_linear_50_4)"/><path d="M16.1995 0.943665C13.1218 0.943665 11.5292 1.98319 9.94585 3.69604L2.16629 13.5442C1.20809 14.804 0.756652 16.0998 0.759289 17.3501H53.3368C53.3395 16.0998 52.8889 14.804 51.9307 13.5442L44.1511 3.69604C42.5678 1.98319 40.9743 0.943665 37.8967 0.943665H16.1995Z" fill="url(#paint2_linear_50_4)"/><path d="M19.4684 0.943665L13.249 17.3501H40.8412L34.6219 0.943665H19.4684Z" fill="url(#paint3_linear_50_4)"/><defs><linearGradient id="paint0_linear_50_4" x1="21.3393" y1="50.8214" x2="21.3393" y2="17.3499" gradientUnits="userSpaceOnUse"><stop stop-color="#E547FF"/><stop offset="1" stop-color="#47E9FF"/></linearGradient><linearGradient id="paint1_linear_50_4" x1="26.8273" y1="49.5651" x2="26.8273" y2="15.6607" gradientUnits="userSpaceOnUse"><stop stop-color="#4E31FF"/><stop offset="1" stop-color="#47E9FF"/></linearGradient><linearGradient id="paint2_linear_50_4" x1="27.0455" y1="-3.65732" x2="27.0455" y2="24.9345" gradientUnits="userSpaceOnUse"><stop stop-color="#1A1E44"/><stop offset="1" stop-color="#47E9FF"/></linearGradient><linearGradient id="paint3_linear_50_4" x1="28.9324" y1="0.0414335" x2="28.9324" y2="16.9446" gradientUnits="userSpaceOnUse"><stop stop-color="#1A1E44"/><stop offset="1" stop-color="#47E9FF"/></linearGradient></defs></svg>
                        <h1 class="mb-2 nova-header">Gem Finders</h1>
                        <h3 class="text-lg text-white">The dawn of a new era is here.</h3>

                        <div class="mt-3">
                            <div v-if="!isLoggedIn">
                                <button v-if="connected == 'Connect'" v-on:click="connect_to_metamask" href="#" :disabled="loggedIn || trying_to_connect" class="font-bold py-2 px-4 rounded mm-fox-button">
                                    <span><span class="float-left text-gray-700">
                                        <span class="" v-if="!trying_to_connect">{{connected}} your wallet</span>
                                        <div v-if="trying_to_connect">
                                            <div class="float-left">
                                                <svg class="animate-spin h-5 w-5 mr-3" viewBox="0 0 24 24">
                                                    <circle class="opacity-10" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>

                                                </svg>
                                            </div>
                                            <div class="float-right">Initializing...</div>
                                        </div>
                                    
                                     <img v-if="!trying_to_connect" class="ml-5 w-6 float-right" src="metamask.4b5d438a.png"></span></span>
                                        
                                </button>

                                <div>
                                    <i v-if="connection_message != ''" class="text-pink-500">{{connection_message}}</i>
                                </div>
                                
                                <i class="" v-if="connected != 'Connect'"><span class="text-white text-lg">Your connected address is</span> <span style="color: #47E9FF" class="">{{connected}}</span></i>
                                
                                <div class="mt-6 -mb-1" v-if="(connected != 'Connect') && !isLoggedIn">
                                    <button class="mm-fox-button font-bold py-2 px-4 rounded" v-on:click="login">
                                        Login
                                        <img class="ml-3 w-6 float-right" src="metamask.4b5d438a.png">
                                    </button>

                                    <div>
                                        {{error}}
                                    </div>

                                </div>
                                <h3 class="text-sm mt-8 text-white">Gem Finders is a collective to identify and invest in the top crypto projects. <p>Membership is by invite only and determined by the group.</p></h3>
                            </div>
                            <div class="mt-10" v-else>
                                <i class="text-white">Your connected address is <span style="color: #47E9FF" class="">{{connected}}</span></i>
                                <h4 class="text-white" v-if="isLoggedIn">You're logged in! Go to the <a class="text-pink-500" href="/home">dashboard</a>.</h4>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    components: {
    },
    data() {
        return {
            invitation: {},

            formValues:{
                email: '',
                password: ''
            },

            error: null,
            loading: false,

            account: "",
            loggedIn: false,
            temp_nonce: "",
            trying_to_connect: false,
            connection_message: ""
        }
    },

    beforeMount(){

    },

    mounted(){
        if (typeof window.ethereum !== 'undefined') {
            this.connection_check();
            console.log('MetaMask is installed!');
        }

        window.ethereum.on('accountsChanged', (accounts) => {
            this.account = accounts[0];
        });


        //WHEN WE'RE DONE WORKING ON LOGIN PAGE WE CAN UNCOMMENT
        //if ( this.isLoggedIn ) {
       //    this.$router.push('/home');
        //}
    },

    computed: {
        ...mapGetters(['isLoggedIn']),

        connected: function() {
            return ( this.account ) ? this.account : "Connect";
        }
    },

    methods: {

        login: async function() {
            await this.connection_check();
            this.authenticate();

        },

        authenticate: async function() {
            await this.get_nonce();
            let address_check = await this.sign_message();
            //console.log(address_check);
        },

        sign_message: async function() {
            
            let msgParams = {
                message: 'Now we securely log you in cause only badass Gem Finding peeps are allowed!',
                primaryType: this.temp_nonce,
                types: {}
            };

            msgParams.types[this.temp_nonce] = [];

            var from = this.account;
            var params = [from, JSON.stringify(msgParams)];
            var method = 'personal_sign';
            var _this = this;
            

            //NEED TO DEPRECATE PREVIOUS METHOD AND IMPLEMENT NEW METHOD WHICH I'VE STARTED BELOW

            
            try {
                var signature = await window.ethereum.request({

                    method,
                    params,
                    from,

                });

                var auth_string = {"signature": signature, "message": msgParams};
                

                const data = _this.$http.post(`/api/auth/authenticate`, auth_string).then( async response => {
                    _this.error = null;
                    let {data} = response;
                    if (data && data.access_token) {
                        await _this.$store.dispatch('auth/login', data);
                        await _this.$store.dispatch('auth/getMe');
                        
                        if (_this.redirect) {
                            const redirect = _this.redirect;
                            if (_this.redirect !== '') {
                                
                                if (['/login', 'login'].includes(_this.redirect)) {
                                
                                    _this.$router.push('/home');
                                    _this.$store.dispatch('auth/setRedirect', null);
                                
                                } else {
                                
                                    _this.$router.push(redirect)
                                    _this.$store.dispatch('auth/setRedirect', null)
                                
                                }
                            }
                        } else {
                            _this.$router.push('/home');
                        }
                    }

                }, response => {
                    _this.error = "This address is not allowed. If you think you should have access then you know who to contact."
                    console.log('NOT ALLOWED!');
                    console.log(response)

                });
            } catch (e) {
                console.log(e);
            }
        },

        get_nonce: async function() {
            const data = await this.$http.get(`/api/auth/nonce?publicAddress=${this.account}`);
            this.temp_nonce = data.data.nonce;
        },

        connect_to_metamask: async function() {
            this.trying_to_connect = true;

            setTimeout(() => {
                if ( !this.loggedIn ) {
                    this.connection_message = "Complete the MetaMask connection if you want to log into your account.";
                }
            }, 10000);

            const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
            this.account = accounts[0];
            //console.log(this.account);

        },
        connection_check: function() {
            if ( this.account == "" ) {
                setTimeout(() => {
                    if ( window.ethereum.selectedAddress ) {
                        this.account = window.ethereum.selectedAddress;
                        this.connection_message = "";
                    }
                }, 1000);
            } else {
                this.loggedIn = true;
            }
        }
    }
}
</script>

<style scoped lang="scss">

    .full-size {
        width: 100%;
        height: 100%;
    }

    .nova-header {
        color: #FFFFFF;
        font-family: regulator-nova,sans-serif;
        font-weight: 700;
        font-style: normal;
        font-size: 34px;
        line-height: 41px;
    }

    .body-scoped {
        background: linear-gradient(180deg, #000000 0%, #1A1E44 51.37%) !important;
    }

    .background-app {
        background-image: url('app_background.svg');
        background-position-x: 50%;
        background-position-y: 202px;
    }

    .mm-fox-button {
        background: #47E9FF;
        font-size: 15px;
        padding: 14px 25px;
    }

</style>